import { useQuery } from '@wyz/utils';
import { IUserCustomer } from '~/common/types';
import { PurchaseQueryKeys, useWcwSearch } from '~/purchase/api';
import { WcwSearchHelpers } from '~/purchase/helpers';
import { IWcwListState, IWcwOffer } from '~/purchase/types';

export function useWcwFilterProducts(
  listState: IWcwListState,
  customer: IUserCustomer,
) {
  const { list } = useWcwSearch({
    list: listState.searchQuery
      ? { args: { customerId: customer.id, query: listState.searchQuery } }
      : undefined,
  });

  const products = list.data?.data ?? [];
  const query = useQuery<IWcwOffer[]>({
    queryKey: PurchaseQueryKeys.wcw.filtered(customer.id, {
      q: listState.searchQuery,
      f: listState.filters,
      s: listState.sort,
      d: list.dataUpdatedAt,
    }),
    queryFn: () => {
      if (products.length === 0) return [];
      const filtered = WcwSearchHelpers.filterWcwProducts(products, listState);
      return WcwSearchHelpers.sortWcwProducts(filtered, listState);
    },
    refetchOnWindowFocus: false,
  });

  return { query, list };
}
